<script lang="ts">
    import FilePicker from "./FilePicker.svelte";
    import Extender from "./Extender.svelte";
    import Library from "./Library.svelte";
    import { globalState, Page } from "./state.svelte";
    import { exportLibrary } from "./import-export/export-library";
    import { importLibrary } from "./import-export/import-library";

    import "@fontsource/roboto/300";
    import "@fontsource/roboto/400";
    import "@fontsource/roboto/500";
    import "@fontsource/roboto/700";
    import TopAppBar, { Row, Section, Title } from "@smui/top-app-bar";
    import IconButton from "@smui/icon-button";
    import Menu from "@smui/menu";
    import List, { Item, Text, Graphic } from "@smui/list";
    import Snackbar, { Label as SbLabel } from "@smui/snackbar";
    import SvgIcon from "./SvgIcon.svelte";
    import {
        mdiArrowLeft,
        mdiDotsVertical,
        mdiUpload,
        mdiDownload,
    } from "@mdi/js";

    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("sw.js");
    }

    let menu: Menu;
    let snackbar: Snackbar;
    let error = $state("");

    /** Wrap a function in an error handling function */
    function handleError(fn: () => Promise<any>) {
        return async () => {
            try {
                await fn();
            } catch (e) {
                error = String(e);
                snackbar.open();
            }
        };
    }
</script>

<TopAppBar variant="static" class="variant">
    <Row>
        <Section>
            <IconButton
                class="variant"
                onclick={() => (globalState.currentPage = Page.filePicker)}
                disabled={globalState.currentPage === Page.filePicker}
            >
                <SvgIcon icon={mdiArrowLeft} />
            </IconButton>
            <Title>Audio Extender</Title>
        </Section>
        <Section align="end">
            <div>
                <IconButton class="variant" onclick={() => menu.setOpen(true)}>
                    <SvgIcon icon={mdiDotsVertical} />
                </IconButton>
                <Menu bind:this={menu}>
                    <List>
                        <Item onSMUIAction={handleError(exportLibrary)}>
                            <Graphic><SvgIcon icon={mdiDownload} /></Graphic>
                            <Text>Export library</Text>
                        </Item>
                        <Item onSMUIAction={handleError(importLibrary)}>
                            <Graphic><SvgIcon icon={mdiUpload} /></Graphic>
                            <Text>Import library</Text>
                        </Item>
                    </List>
                </Menu>
            </div>
        </Section>
    </Row>
</TopAppBar>

<main>
    {#if globalState.currentPage === Page.filePicker}
        <FilePicker />
    {:else if globalState.currentPage === Page.library}
        <Library />
    {:else}
        <Extender />
    {/if}
</main>

<Snackbar bind:this={snackbar}>
    <SbLabel>Error: {error}</SbLabel>
</Snackbar>

<style>
    main {
        text-align: center;
    }
</style>
